<div class="loading-backdrop" [class.blur]="fullscreen && blur">
  <div class="loading-content">
    <mat-spinner [diameter]="diameter" />
    @if (message) {
      <span class="loading-message">{{ message }}</span>
    }
  </div>
</div>
